export const Keys = {
    ESCAPE: 'escape',
    RIGHT: 'right',
    LEFT: 'left',
};
